import { bandForConfidence, type ConfidenceBand } from '@shared/config/confidence';
import type { ExtractionStatus } from '@shared/schema/billData';

const BAND_STYLES: Record<ConfidenceBand, string> = {
  high: 'bg-emerald-50 text-emerald-800',
  medium: 'bg-amber-50 text-amber-800',
  low: 'bg-red-50 text-red-800',
};

const BAND_ICON: Record<ConfidenceBand, string> = { high: '🟢', medium: '🟡', low: '🔴' };
const BAND_LABEL: Record<ConfidenceBand, string> = {
  high: 'High confidence',
  medium: 'Review',
  low: 'Low confidence',
};

interface ConfidenceBadgeProps {
  status: ExtractionStatus;
  confidence: number;
}

export default function ConfidenceBadge({ status, confidence }: ConfidenceBadgeProps) {
  if (status === 'missing') {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-2.5 py-1 text-xs font-medium text-slate-600">
        Not found — enter manually
      </span>
    );
  }
  if (status === 'user_edited') {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-blue-50 px-2.5 py-1 text-xs font-medium text-blue-700">
        ✏️ Edited by you
      </span>
    );
  }

  const band = bandForConfidence(confidence);
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium ${BAND_STYLES[band]}`}
    >
      <span aria-hidden="true">{BAND_ICON[band]}</span>
      {BAND_LABEL[band]}
    </span>
  );
}
